/* Giorgio — Shop by category rail.
   Scrolls one tile at a time and hides an arrow once that end is reached. */
(function () {
  function init(section) {
    if (section.dataset.gioCatsReady === 'true') return;
    section.dataset.gioCatsReady = 'true';

    var rail = section.querySelector('[data-gio-catrail]');
    var prev = section.querySelector('[data-gio-cat-prev]');
    var next = section.querySelector('[data-gio-cat-next]');
    if (!rail || !prev || !next) return;

    function step() {
      var tile = rail.querySelector('.cat');
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 24;
      return tile ? tile.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }

    function sync() {
      var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      prev.disabled = rail.scrollLeft <= pad + 8;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - pad - 8;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-gio-cats]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor re-renders a section without reloading the page.
  document.addEventListener('shopify:section:load', boot);
})();
